import { createApp } from 'vue'
import VueGtag from 'vue-gtag-next'
import PortalVue from 'portal-vue'
import App from '@/App'
import router from '@/router'
import { store } from '@/store'
import VCalendar from 'v-calendar'

import directives from '@/plugins/directives'
import dragAndDrop from '@/plugins/dragAndDrop'

import '@/assets/scss/main.scss'

const app = createApp(App)

app.use(PortalVue)
app.use(store)
app.use(router)
app.use(directives)
app.use(dragAndDrop)
app.use(VCalendar, {})

app.use(VueGtag, {
  property: [
    { id: 'UA-181573076-1' },
    { id: 'G-H3G008DV0V' },
    { id: 'AW-597169833' }
  ]
})

app.mount('#app')
